import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import Form from '../../layout/form/Form';
import ContentCadastro from '../../layout/content/ContentCadastro';
import NavTab from '../../layout/nav/NavTab';
import ServiceNav from '../../layout/nav/ServiceNav';
import Input from '../../layout/input/Input';
import Geral from './Geral';
import Desktop from './Desktop';
import Mobile from './Mobile';

import TemaService from '../../../service/TemaService';

import { getParam } from '../../../helper/Url';

class Cadastro extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            salvar: {
                disabled: true,
                name: 'Salvar'
            },

            erro: {
                message: '',
                code: 0
            },

            preload: false,

            sucesso: false,            

            modalErroMsg: {
                message: '',
                code: 0
            },

            form: {
                id: 0,
                descricao: '',

                //Geral
                background_thema: '#ea1d2c',
                color_thema: '#ffffff',                
                background_button: '#ea1d2c',
                color_button: '#ffffff',
                background_button_hover: '#c2121f',
                color_button_hover: '#ffffff',
                color_link_acao: '#ea1d2c',
                color_link_remover: '#a6a29f',
                background_btn_voltar: '#0069d9',
                color_btn_voltar: '#ffffff',
                background_btn_voltar_hover: '#0069d9',
                color_btn_voltar_hover: '#ffffff',

                //Desktop
                background_header_desktop: '#ffffff',
                color_icon_header_desktop: '#ea1d2c',
                color_primaria_header: '#a6a5a5',
                color_secundaria_header: '#3e3e3e',
                color_secundaria_header_hover: '#ea1d2c',
                cor_lbl_icon_menu_top: '#ffffff',
                color_badge_border: '#ffffff',
                background_badge_desktop: '#ea1d2c',
                color_badge_desktop: '#ffffff',

                //Mobile
                color_header_mobile: '#ffffff',
                background_footer_mobile: '#ffffff',
                color_icon_footer_mobile: '#3f3e3e',
                color_icon_footer_mobile_active: '#ea1d2c',
                background_badge_mobile: '#440e62',
                color_badge_mobile: '#ffffff',
                background_cart_mobile: '#ea1d2c',
                color_cart_mobile: '#ffffff',
                background_bagde_cart_mobile: '#ffffff',
                color_bagde_cart_mobile: '#ea1d2c'
            },

            erroForm: {
                descricao: '',
                
                //Geral
                background_thema: '',
                color_thema: '',                
                background_button: '',
                color_button: '',
                background_button_hover: '',
                color_button_hover: '',
                color_link_acao: '',
                color_link_remover: '',
                background_btn_voltar: '',
                color_btn_voltar: '',
                background_btn_voltar_hover: '',
                color_btn_voltar_hover: '',

                //Desktop
                background_header_desktop: '',
                color_icon_header_desktop: '',
                color_primaria_header: '',
                color_secundaria_header: '',
                color_secundaria_header_hover: '',
                cor_lbl_icon_menu_top: '',
                color_badge_border: '',
                background_badge_desktop: '',
                color_badge_desktop: '',

                //Mobile
                color_header_mobile: '',
                background_footer_mobile: '',
                color_icon_footer_mobile: '',
                color_icon_footer_mobile_active: '',
                background_badge_mobile: '',
                color_badge_mobile: '',
                background_cart_mobile: '',
                color_cart_mobile: '',
                background_bagde_cart_mobile: '',
                color_bagde_cart_mobile: ''
            }
        }

        this.nav = new ServiceNav();
        
        this.nav.addComponent(
            1,
            'geral', 
            'Geral', 
            false,                                                 
            Geral,
            {
                form: this.state.form,
                erroForm: this.state.erroForm,                                
                onChange: (e) => this.onChange(e),   
                onValidaLogo: () => this.onValidaLogo()
            }
        ); 

        this.nav.addComponent(
            2,
            'desktop', 
            'Desktop', 
            false,                                                 
            Desktop,
            {
                form: this.state.form,
                erroForm: this.state.erroForm,                                
                onChange: (e) => this.onChange(e),   
                onValidaLogo: () => this.onValidaLogo()
            }
        );

        this.nav.addComponent(
            3,
            'mobile', 
            'Mobile', 
            false,                                                 
            Mobile,
            {
                form: this.state.form,
                erroForm: this.state.erroForm,                                
                onChange: (e) => this.onChange(e),   
                onValidaLogo: () => this.onValidaLogo()
            }
        );
    }

    onChange(e) {        
        var form = this.state.form;                         
                
        form[e.target.name] = e.target.value;

        var salvar = this.state.salvar;
        
        salvar.disabled = false;        

        this.setState({
            form: form,
            salvar: salvar
        });
    } 

    showPage(index, show) {
        const nav = this.nav.getMenu();
        const menu = nav[index];        
        const props = menu.props;

        menu.props.visible = show;        
        menu.props = props;        

        nav.splice(index, 1, menu);

        this.nav.setMenu(nav);
    } 

    limparErroForm() {
        var erroForm = this.state.erroForm;

        erroForm.background_thema = '';
        erroForm.color_thema = '';                
        erroForm.background_button = '';
        erroForm.color_button = '';
        erroForm.background_button_hover = '';
        erroForm.color_button_hover = '';
        erroForm.color_link_acao = '';
        erroForm.color_link_remover = '';
        erroForm.background_btn_voltar = '';
        erroForm.color_btn_voltar = '';
        erroForm.background_btn_voltar_hover = '';
        erroForm.color_btn_voltar_hover = '';

        //Desktop
        erroForm.background_header_desktop = '';
        erroForm.color_icon_header_desktop = '';
        erroForm.color_primaria_header = '';
        erroForm.color_secundaria_header = '';
        erroForm.color_secundaria_header_hover = '';
        erroForm.cor_lbl_icon_menu_top = '';
        erroForm.color_badge_border = '';
        erroForm.background_badge_desktop = '';
        erroForm.color_badge_desktop = '';

        //Mobile
        erroForm.color_header_mobile = '';
        erroForm.background_footer_mobile = '';
        erroForm.color_icon_footer_mobile = '';
        erroForm.color_icon_footer_mobile_active = '';
        erroForm.background_badge_mobile = '';
        erroForm.color_badge_mobile = '';
        erroForm.background_cart_mobile = '';
        erroForm.color_cart_mobile = '';
        erroForm.background_bagde_cart_mobile = '';
        erroForm.color_bagde_cart_mobile = '';

        this.setState({
            erroForm: erroForm
        });

        this.nav.clearIndexErro();
    }

    canSave() {
        this.limparErroForm();

        var form = this.state.form;
        var erroForm = this.state.erroForm;
        var erro = false;
        var index0Erro = false;
        var index1Erro = false;
        var index2Erro = false;        
        
        if(!form.background_thema) {
            erroForm.background_thema = "Informe o campo Background Thema";
            index0Erro = true;
            erro = true;
        } 

        if(!form.color_thema) {
            erroForm.color_thema = "Informe o campo Color Thema";
            index0Erro = true;
            erro = true;
        } 

        if(!form.background_button) {
            erroForm.background_button = "Informe o campo Background Button";
            index0Erro = true;
            erro = true;
        }

        if(!form.color_button) {
            erroForm.color_button = "Informe o campo Color Button";
            index0Erro = true;
            erro = true;
        }

        if(!form.background_button_hover) {
            erroForm.background_button_hover = "Informe o campo Background Button Hover";
            index0Erro = true;
            erro = true;
        }

        if(!form.color_button_hover) {
            erroForm.color_button_hover = "Informe o campo Color Button Hover";
            index0Erro = true;
            erro = true;
        }

        if(!form.color_link_acao) {
            erroForm.color_link_acao = "Informe o campo Color Link Ação";
            index0Erro = true;
            erro = true;
        }
       
        if(!form.color_link_remover) {
            erroForm.color_link_remover = "Informe o campo Color Link Remover";
            index0Erro = true;
            erro = true;
        }

        if(!form.background_btn_voltar) {
            erroForm.background_btn_voltar = 'Informe o campo Background Button "Voltar"';
            index0Erro = true;
            erro = true;
        }

        if(!form.color_btn_voltar) {
            erroForm.color_btn_voltar = 'Informe o campo Color Button "Voltar"';
            index0Erro = true;
            erro = true;
        }

        if(!form.background_btn_voltar_hover) {
            erroForm.background_btn_voltar_hover = 'Informe o campo Background Button "Voltar" Hover';
            index0Erro = true;
            erro = true;
        }

        if(!form.color_btn_voltar_hover) {
            erroForm.color_btn_voltar_hover = 'Informe o campo Color Button "Voltar" Hover';
            index0Erro = true;
            erro = true;
        }                        

        //Desktop
        if(!form.background_header_desktop) {
            erroForm.background_header_desktop = 'Informe o campo Background Header';
            index1Erro = true;
            erro = true;
        }   

        if(!form.color_icon_header_desktop) {
            erroForm.color_icon_header_desktop = 'Informe o campo Color Icon Header';
            index1Erro = true;
            erro = true;
        }   

        if(!form.color_primaria_header) {
            erroForm.color_primaria_header = 'Informe o campo Color Primaria Header';
            index1Erro = true;
            erro = true;
        }  
        
        if(!form.color_secundaria_header) {
            erroForm.color_secundaria_header = 'Informe o campo Color Secundária Header';
            index1Erro = true;
            erro = true;
        } 
        
        if(!form.color_secundaria_header_hover) {
            erroForm.color_secundaria_header_hover = 'Informe o campo Color Secundaria Header Hover';
            index1Erro = true;
            erro = true;
        }

        if(!form.cor_lbl_icon_menu_top) {
            erroForm.cor_lbl_icon_menu_top = 'Informe o campo Color Label Icon Header';
            index1Erro = true;
            erro = true;
        }

        if(!form.color_badge_border) {
            erroForm.color_badge_border = 'Informe o campo Color Badge Border';
            index1Erro = true;
            erro = true;
        }

        if(!form.background_badge_desktop) {
            erroForm.background_badge_desktop = 'Informe o campo Background Badge Desktop';
            index1Erro = true;
            erro = true;
        }

        if(!form.color_badge_desktop) {
            erroForm.color_badge_desktop = 'Informe o campo Color Badge';
            index1Erro = true;
            erro = true;
        }                            

        //Mobile
        if(!form.color_header_mobile) {
            erroForm.color_header_mobile = 'Informe o campo Color Header';
            index2Erro = true;
            erro = true;
        }
        
        if(!form.background_footer_mobile) {
            erroForm.background_footer_mobile = 'Informe o campo Background Footer';
            index2Erro = true;
            erro = true;
        } 

        if(!form.color_icon_footer_mobile) {
            erroForm.color_icon_footer_mobile = 'Informe o campo Color Icon Footer';
            index2Erro = true;
            erro = true;
        } 

        if(!form.color_icon_footer_mobile_active) {
            erroForm.color_icon_footer_mobile_active = 'Informe o campo Color Icon Footer Active';
            index2Erro = true;
            erro = true;
        }         
        
        if(!form.background_badge_mobile) {
            erroForm.background_badge_mobile = 'Informe o campo Background Badge';
            index2Erro = true;
            erro = true;
        }         

        if(!form.color_badge_mobile) {
            erroForm.color_badge_mobile = 'Informe o campo Color Badge';
            index2Erro = true;
            erro = true;
        }         

        if(!form.background_cart_mobile) {
            erroForm.background_cart_mobile = 'Informe o campo Background Carrinho';
            index2Erro = true;
            erro = true;
        }  
        
        if(!form.color_cart_mobile) {
            erroForm.color_cart_mobile = 'Informe o campo Color Carrinho';
            index2Erro = true;
            erro = true;
        }  

        if(!form.background_bagde_cart_mobile) {
            erroForm.background_bagde_cart_mobile = 'Informe o campo Background Badge Carrinho';
            index2Erro = true;
            erro = true;
        }  

        if(!form.color_bagde_cart_mobile) {
            erroForm.color_bagde_cart_mobile = 'Informe o campo Color Badge Carrinho';
            index2Erro = true;
            erro = true;
        }  
        
        if(erro) {            
            if(index0Erro)
                this.nav.setIndexErro(0);
            
            if(index1Erro)
                this.nav.setIndexErro(1);
            
            if(index2Erro)
                this.nav.setIndexErro(2);                    

            this.setState({erroForm: erroForm});            

            return false;
        }

        return true;
    }

    onSubmit(e) {        
        if(!this.canSave())            
            return ;        
            
        var salvar = this.state.salvar;

        salvar.disabled = true;
        salvar.name = 'Aguarde...';

        this.setState({ 
            salvar: salvar,
            erro: {
                message: '',
                code: 0
            }
        }); 
        
        const form = new FormData(document.getElementById('form'));         

        TemaService.gravar(
            form
        ).then(() => {
            var salvar = this.state.salvar;
        
            salvar.name = 'Salvar';

            this.setState({
                salvar: salvar,
                sucesso: true
            });
        }).catch((erro) => {
            var salvar = this.state.salvar;

            salvar.disabled = false;
            salvar.name = 'Salvar';

            this.setState({
                erro: this.trataErro(erro),
                salvar: salvar
            });
        });
    }    

    componentDidMount() {
        const id = getParam('id');        

        if((id === undefined)||(id === null)||(id === 0))
            return ;            

        this.setState({
            modalErroMsg: {
                message: '',
                code: 0
            },
            preload: true
        });

        TemaService.buscar(id).then(resposta => {
            let form = this.state.form;            

            form.id = resposta.data.id;   
            form.descricao = resposta.data.descricao;     
            
            //Geral
            form.background_thema = resposta.data.background_thema;           
            form.color_thema = resposta.data.color_thema;              
            form.background_button = resposta.data.background_button;           
            form.color_button = resposta.data.color_button;           
            form.background_button_hover = resposta.data.background_button_hover;           
            form.color_button_hover = resposta.data.color_button_hover;           
            form.color_link_acao = resposta.data.color_link_acao;           
            form.color_link_remover = resposta.data.color_link_remover;           
            form.background_btn_voltar = resposta.data.background_btn_voltar;           
            form.color_btn_voltar = resposta.data.color_btn_voltar;           
            form.background_btn_voltar_hover = resposta.data.background_btn_voltar_hover;           
            form.color_btn_voltar_hover = resposta.data.color_btn_voltar_hover;            
            
            //Desktop
            form.background_header_desktop = resposta.data.background_header_desktop;           
            form.color_icon_header_desktop = resposta.data.color_icon_header_desktop;           
            form.color_primaria_header = resposta.data.color_primaria_header;           
            form.color_secundaria_header = resposta.data.color_secundaria_header;           
            form.color_secundaria_header_hover = resposta.data.color_secundaria_header_hover;           
            form.cor_lbl_icon_menu_top = resposta.data.cor_lbl_icon_menu_top;           
            form.color_badge_border = resposta.data.color_badge_border;           
            form.background_badge_desktop = resposta.data.background_badge_desktop;           
            form.color_badge_desktop = resposta.data.color_badge_desktop;            
            
            //Mobile
            form.color_header_mobile = resposta.data.color_header_mobile;           
            form.background_footer_mobile = resposta.data.background_footer_mobile;          
            form.color_icon_footer_mobile = resposta.data.color_icon_footer_mobile;           
            form.color_icon_footer_mobile_active = resposta.data.color_icon_footer_mobile_active;           
            form.background_badge_mobile = resposta.data.background_badge_mobile;           
            form.color_badge_mobile = resposta.data.color_badge_mobile;           
            form.background_cart_mobile = resposta.data.background_cart_mobile;           
            form.color_cart_mobile = resposta.data.color_cart_mobile;           
            form.background_bagde_cart_mobile = resposta.data.background_bagde_cart_mobile;           
            form.color_bagde_cart_mobile = resposta.data.color_bagde_cart_mobile;           
            
            this.setState({
                form: form,
                modalErroMsg: {
                    message: '',
                    code: 0
                },
                preload: false
            });
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });        
    }

    render() {
        return(                                                                             
            <div>
                <Form onSubmit={(e) => this.onSubmit(e)} id="form">                    
                    <input type="hidden" name="id" id="id" value={this.state.form.id} />
                    <input type="hidden" name="usuario" id="usuario" value={this.props.usuario.nome} />

                    {/* Geral */}
                    <input type="hidden" name="background_thema" id="background_thema" value={this.state.form.background_thema} />
                    <input type="hidden" name="color_thema" id="color_thema" value={this.state.form.color_thema} />
                    <input type="hidden" name="background_button" id="background_button" value={this.state.form.background_button} />
                    <input type="hidden" name="color_button" id="color_button" value={this.state.form.color_button} />
                    <input type="hidden" name="background_button_hover" id="background_button_hover" value={this.state.form.background_button_hover} />
                    <input type="hidden" name="color_button_hover" id="color_button_hover" value={this.state.form.color_button_hover} />
                    <input type="hidden" name="color_link_acao" id="color_link_acao" value={this.state.form.color_link_acao} />
                    <input type="hidden" name="color_link_remover" id="color_link_remover" value={this.state.form.color_link_remover} />
                    <input type="hidden" name="background_btn_voltar" id="background_btn_voltar" value={this.state.form.background_btn_voltar} />
                    <input type="hidden" name="color_btn_voltar" id="color_btn_voltar" value={this.state.form.color_btn_voltar} />
                    <input type="hidden" name="background_btn_voltar_hover" id="background_btn_voltar_hover" value={this.state.form.background_btn_voltar_hover} />
                    <input type="hidden" name="color_btn_voltar_hover" id="color_btn_voltar_hover" value={this.state.form.color_btn_voltar_hover} />

                    {/* Desktop */}
                    <input type="hidden" name="background_header_desktop" id="background_header_desktop" value={this.state.form.background_header_desktop} />
                    <input type="hidden" name="color_icon_header_desktop" id="color_icon_header_desktop" value={this.state.form.color_icon_header_desktop} />
                    <input type="hidden" name="color_primaria_header" id="color_primaria_header" value={this.state.form.color_primaria_header} />
                    <input type="hidden" name="color_secundaria_header" id="color_secundaria_header" value={this.state.form.color_secundaria_header} />
                    <input type="hidden" name="color_secundaria_header_hover" id="color_secundaria_header_hover" value={this.state.form.color_secundaria_header_hover} />
                    <input type="hidden" name="cor_lbl_icon_menu_top" id="cor_lbl_icon_menu_top" value={this.state.form.cor_lbl_icon_menu_top} />
                    <input type="hidden" name="color_badge_border" id="color_badge_border" value={this.state.form.color_badge_border} />
                    <input type="hidden" name="background_badge_desktop" id="background_badge_desktop" value={this.state.form.background_badge_desktop} />
                    <input type="hidden" name="color_badge_desktop" id="color_badge_desktop" value={this.state.form.color_badge_desktop} />

                    {/* Mobile */}
                    <input type="hidden" name="color_header_mobile" id="color_header_mobile" value={this.state.form.color_header_mobile} />
                    <input type="hidden" name="background_footer_mobile" id="background_footer_mobile" value={this.state.form.background_footer_mobile} />
                    <input type="hidden" name="color_icon_footer_mobile" id="color_icon_footer_mobile" value={this.state.form.color_icon_footer_mobile} />
                    <input type="hidden" name="color_icon_footer_mobile_active" id="color_icon_footer_mobile_active" value={this.state.form.color_icon_footer_mobile_active} />
                    <input type="hidden" name="background_badge_mobile" id="background_badge_mobile" value={this.state.form.background_badge_mobile} />
                    <input type="hidden" name="color_badge_mobile" id="color_badge_mobile" value={this.state.form.color_badge_mobile} />
                    <input type="hidden" name="background_cart_mobile" id="background_cart_mobile" value={this.state.form.background_cart_mobile} />
                    <input type="hidden" name="color_cart_mobile" id="color_cart_mobile" value={this.state.form.color_cart_mobile} />
                    <input type="hidden" name="background_bagde_cart_mobile" id="background_bagde_cart_mobile" value={this.state.form.background_bagde_cart_mobile} />
                    <input type="hidden" name="color_bagde_cart_mobile" id="color_bagde_cart_mobile" value={this.state.form.color_bagde_cart_mobile} />

                    <ContentCadastro 
                        title="Configurações do Tema"
                        history="configuracao/tema"

                        preload={this.state.preload || this.props.preload}
                        sucesso={this.state.sucesso}
                        textoSucesso="Tema salvo com sucesso"
                        modalErroMsg={this.state.modalErroMsg}

                        salvar={this.state.salvar}    
                        erro={this.state.erro}                

                        onSalvar="submit"                    
                        onSucesso={() => this.setState({sucesso: false})}
                        fecharModal={() => this.setState({modalErroMsg: this.finalizaErro(this.state.modalErroMsg)})}

                        route={(route) => this.props.route(route)}
                    >        
                        <Input
                            md={12} 
                            xs={12} 
                            sm={12} 
                            lg={12}
                            id="descricao"
                            nome="descricao"
                            maxLength={17}
                            value={this.state.form.descricao}
                            defaultValue={this.state.form.descricao}                            
                            erro={this.state.erroForm.alias_app}                    
                            onChange={e => this.onChange(e)}
                        >
                            Descrição
                        </Input>     
                        
                        <NavTab
                            nav={this.nav.getMenu()}  
                            indexErro={this.nav.getIndexErro()}
                        />
                    </ContentCadastro>            
                </Form>
            </div>
        )
    }
}

export default Cadastro;